import React from 'react';
import {
  Switch, Route, withRouter
} from 'react-router-dom';
import AccountSpinner from 'pages/Setup/AccountSpinner';
import AccountCreated from 'pages/Setup/AccountCreated';
import WhereToAdd from 'pages/Setup/ExistingAccounts';

/* eslint-disable react/prefer-stateless-function */
class Setup extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route
            exact
            path="/setup/spinner"
            component={ AccountSpinner }
          />
          <Route
            exact
            path="/setup/accountcreated"
            component={ AccountCreated }
          />
          <Route
            exact
            path="/setup/wheretoadd"
            component={ WhereToAdd }
          />
          <Route
            exact
            path="/setup"
            component={ WhereToAdd }
          />
        </Switch>
      </React.Fragment>
    );
  }
}

export default withRouter(Setup);
